import Vue from 'vue'
// 支持IE
// import 'babel-polyfill'
// 引入element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入axios
import axios from 'axios'

// 引入全局样式文件
import './assets/css/global/global.css'
// 是否开启vue开发提示
Vue.config.productionTip = true

// 引入element-ui
Vue.use(ElementUI)

// axios 设置
Vue.prototype.axios = axios
// 设置请求拦截器
axios.interceptors.request.use(config => {
  // console.log(config)
  const token = localStorage.getItem('Token')
  if (token) {
    config.headers.token = token
  }
  return config
})

// 全局常量和函数
Vue.prototype.global = {
  iotName: process.env.VUE_APP_IOT_NAME,
  projectName: process.env.VUE_APP_PROJECT_NAME,
  url: {
    baseUrl: process.env.VUE_APP_BASE_URL,
    wsUrl: process.env.VUE_APP_WS_URL
  },
  token: {
    getToken: function () {
      localStorage.getItem('Token')
    },
    setToken: function (token) {
      localStorage.setItem('Token', token)
    },
    removeToken: function () {
      localStorage.removeItem('Token')
    }
  },
  dateFormat: function (shijianchuo) {
    function add0 (m) { return m < 10 ? '0' + m : m }
    var time = new Date(shijianchuo)
    var y = time.getFullYear()
    var m = time.getMonth() + 1
    var d = time.getDate()
    var h = time.getHours()
    var mm = time.getMinutes()
    var s = time.getSeconds()
    return y + '-' + add0(m) + '-' + add0(d) + ' ' + add0(h) + ':' + add0(mm) + ':' + add0(s)
  }
}

// 全局验证
Vue.prototype.validate = {
  vdEmail: function (value) {
    let res = {
      success: false,
      code: 201,
      msg: ''
    }
    if (value.length <= 0) {
      res.success = false
      res.code = 201
      res.msg = '邮箱不能为空'
      return res
    }
    const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
    if (mailReg.test(value)) {
      res.success = true
      res.code = 206
      res.msg = '邮箱验证正确'
    } else {
      res.success = false
      res.code = 202
      res.msg = '邮箱格式不正确'
    }
    return res
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
